import OrganizationSubjects from './OrganizationSubjects';

export default OrganizationSubjects;
